module.exports = __webpack_public_path__ + "static/media/P1000-Tip.6cd44f12.svg";